// extracted by mini-css-extract-plugin
export var wrapper = "SectionDivider-module__wrapper___Oz7yY";
export var text = "SectionDivider-module__text___RqYoS";
export var line = "SectionDivider-module__line___peBQr";